
<div class="dropdown-container">
  <div *ngIf="treeData">
    <div *ngFor="let node of treeData">
      <!-- level container -->
      <div
        [ngClass]="{
          'parent-level-container': node.isParent,
          'child-level-container': !node.isParent
        }"
      >
        <!-- dropdown cell container -->
        <div
          [ngClass]="{
            'dropdown-cell-container parent-level': node.isParent,
            'dropdown-cell-container child-level': !node.isParent
          }"
          [hidden]="!node.children"
          *ngIf="node.name"
        >
          <div class="title-container">
            <div class="button-title-container">
              <button
                (click)="toggleChild(node)"
                [hidden]="!node.children || node.children.length == 0"
                class="btn-drop"
              >
                <!-- Expand / Collapse -->
                <img
                  src="../../../assets/icons/back-icon.svg"
                  class="rotation-img"
                  [class.rotation-img-up]="rotation"
                />
              </button>

              <p>{{ node.name }}</p>
              <!-- <p *ngIf="node.isParent"> ( {{countCheckeds}} ) </p> -->
            </div>

            <div class="checkbox-container">
              <input
              type="checkbox"
              class="checkmark"
              [(ngModel)]="node.isChecked"
              value="{{node.id}}"
              (change)="changeItem(node)"
              [disabled]="!node.isCheckable"
              />
            </div>
          </div>
        </div>

        <app-tree
          *ngIf="node.showChildren"
          [treeData]="node.children"
          (emitterConfirmEnable)="enableConfirmButton($event)"
          ></app-tree>
          <!-- (itemChanged)="changeItem($event)" -->

        <!-- Children -->
      </div>
      <!-- Parent -->
    </div>
  </div>
</div>
